<template>
<div id="customerUserInfo" class="container section-container">
  <h3 class="titleTyle">本地生活</h3>
  <el-row class="headBox">
    <el-col :span="6"><div class="userHead">
      <img :src="localInfo.memberAvatar">
    </div></el-col>
    <el-col :span="18">
      <el-row :gutter="24" class="lay-m-t-s" v-if="localInfo.memberName">
        <el-col :span="24">{{localInfo.memberName}}</el-col>
      </el-row>
      <el-row :gutter="24" class="lay-m-t-d">
        <el-col :span="24">
          <div>unionID:</div>{{localInfo.unionID}}
        </el-col>
      </el-row>
      <el-row :gutter="24" class="lay-m-t-d">
        <el-col :span="24">
          手机号:{{localInfo.mobile?localInfo.mobile:'-'}}
        </el-col>
      </el-row>
    </el-col>
  </el-row>
  <!-- <hr class="hrLine" v-if="localInfo.servicesSiteInfoList.length">
  <el-row class="headBox" v-if="localInfo.servicesSiteInfoList.length">
    <el-col :span="24" v-for="(history,index) in localInfo.servicesSiteInfoList" :key="index">
      <el-row :gutter="18" class="lay-m-t-s">
        <el-col :span="18">历史下单写字楼：{{history.servicesSiteName}}</el-col>
      </el-row>
       <el-row :gutter="18" class="lay-m-t-s">
        <el-col :span="18">下单次数：{{history.orderNumber}}</el-col>
      </el-row>
      <el-row :gutter="18" class="lay-m-t-s">
       <hr class="hrLine">
      </el-row>
    </el-col>
  </el-row>
  <hr class="hrLine">
  <h3 class="titleTyle">车务</h3>
  <el-row class="headBox">
    <el-col :span="6"><div class="userHead">
      <img :src="userInfo.memberAvatar">
    </div></el-col>
    <el-col :span="18">
      <span @click="setStar(userInfo)" class="to_able" v-if="userInfo.isStar" ><i class="el-icon-star-on oooc"></i></span>
      <span @click="setStar(userInfo)" style="cursor:pointer;" v-else><i class="el-icon-star-on oooc"></i></span>
      <el-row :gutter="5" class="lay-m-t-s">
        <el-col :span="10">{{userInfo.memberName}}</el-col>
        <el-col :span="5" v-if="userInfo.svip">SVIP</el-col>
        <el-col :span="5" v-else-if="userInfo.vip">VIP</el-col>
        <el-col :span="5" v-else></el-col>
      </el-row>
      <el-row :gutter="5" class="lay-m-t-d">
        <el-col :span="4" v-if="userInfo.memberSex == '0'">男</el-col>
        <el-col :span="4" v-else-if="userInfo.memberSex == '1'">女</el-col>
        <el-col :span="4" v-else>-</el-col>
        <el-col :span="6">{{userInfo.levelName}}</el-col>
        <el-col :span="14">{{userInfo.isAgent ? '普通合伙人' : ''}}</el-col>
      </el-row>
    </el-col>
  </el-row>

  <hr class="hrLine">

  <el-form label-width="80px">
    <el-form-item label="手机:">
      {{userInfo.mobile || '-'}}
    </el-form-item>
    <el-form-item label="邮箱:">
      <div v-if="!userDataEdit.editEmail">
        <div class="lmtWid ovh">
          {{userInfo.memberEmail || '-'}}
        </div> <i class="fa fa-pencil-square-o iconAble edit" title="编辑" @click="editUserInfo('Email')"></i>
      </div>
      <div class="changeEditable" v-else>
        <el-input v-model="userDataEdit.dataEmail" placeholder="请输入邮箱号"></el-input>
        <i class="fa fa-check iconAble iconYes" title="保存" @click="saveUserInfo('Email')"></i>
        <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleUserInfo('Email')"></i>
      </div>
    </el-form-item>
    <el-form-item label="个性签名:" :title="userInfo.memberSign">
      <div class="lmtWid ovh">{{userInfo.memberSign || '-'}}</div>
    </el-form-item>
    <el-form-item label="城市:">
      <div v-if="!userDataEdit.editCity">
        <span class="ovh"
              style="display: inline-block; max-width: 172px; vertical-align: bottom;"
              :title="userInfo.city"
        >{{userInfo.city || '-'}}</span> <i class="fa fa-pencil-square-o iconAble edit" title="编辑" @click="editUserInfo('City')"></i>
      </div>
      <div class="changeEditable a1" v-else>
        <el-select v-model="userDataEdit.dataProvince"
                   @change="searchCitys"
                   placeholder="省份" clearable>
          <el-option :value="item.areaId"
                     :label="item.areaName"
                     v-for="item in provinceList"
                     :key="item.areaId"></el-option>
        </el-select>
        <el-select v-model="userDataEdit.dataCity"
                   placeholder="城市" clearable>
          <el-option :value="item.areaId"
                     :label="item.areaName"
                     v-for="item in cityList"
                     :key="item.areaId"></el-option>
        </el-select>
        <i class="fa fa-check iconAble iconYes" title="保存" @click="saveUserInfo('City')"></i>
        <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleUserInfo('City')"></i>
      </div>
    </el-form-item>
  </el-form>

  <hr class="hrLine">

  <el-form label-width="80px">
    <el-form-item label="实名认证:">
      {{userInfo.xm || '-'}}
      <i class="fa fa-pencil-square-o iconAble edit"
         title="编辑"
         v-if="userInfo.drvBindId != ''"
         @click="openDrvDialog()"></i>
    </el-form-item>
    <el-form-item label="初次领证:">
      {{userInfo.firstBindDate || '-'}}
    </el-form-item>
  </el-form> -->

  <hr class="hrLine">

  <el-form label-width="80px" v-if="userInfo.cardid">
    <el-form-item label="友途卡编号:">
      {{userInfo.cardid}}
    </el-form-item>
    <el-form-item label="双签状态:">
      <span v-for="item in statusList" v-if="item.value == userInfo.signStatus" :key="item.value">{{item.name}}</span>
      <div class="lineRight">
        <span class="likeA" @click="syncState">同步双签状态</span>
      </div>
    </el-form-item>
    <el-form-item label="开卡时间:">
      {{userInfo.signDate}}
    </el-form-item>
  </el-form>

  <!-- <hr class="hrLine">

  <el-form label-width="80px" v-if="userInfo.managerId !== ''">
    <el-form-item label="所属管家:">
      {{userInfo.managerId}}
    </el-form-item>
    <el-form-item label="注册方式:">
      {{userInfo.registerType}}
    </el-form-item>
    <el-form-item label="注册时间:">
      {{userInfo.strRegisterTime}}
    </el-form-item>
    <el-form-item label="累计登录:">
      {{userInfo.loginCount}}次
      <div class="lineRight">
        <span class="likeA" @click="openMoreActive">更多活跃信息</span>
      </div>
    </el-form-item>
  </el-form>

  <hr class="hrLine"> -->

  <!-- <el-form label-width="80px">
    <el-form-item label="选择油卡:">
      <el-select v-model="userInfo.curOilCard.scardid"
                 @change="changeSelectOilCard"
                 v-if="userInfo.cardList.length > 0"
                 placeholder="油卡">
        <el-option v-for="item in userInfo.cardList"
                   :key="item.scardid"
                   :value="item.scardid"
                   :label="item.scardid"></el-option>
      </el-select>
      <div v-else>未绑定油卡</div>
    </el-form-item>
    <el-form-item label="油卡类型:">
      {{userInfo.curOilCard.isMasterCard || '-'}}
      <div class="lineRight" v-if="userInfo.cardList.length > 0">
        <span class="likeA" @click="getAddOilRecord">加油记录</span>
      </div>
    </el-form-item>
    <el-form-item label="备注信息:" :title="userInfo.curOilCard.describe">
      <div v-if="!userDataEdit.editOilCardNote">
        <div class="lmtWid ovh">{{userInfo.curOilCard.describe || '-'}}</div>
        <i class="fa fa-pencil-square-o iconAble edit"
           title="编辑"
           v-if="userInfo.cardList.length > 0"
           @click="editUserInfo('OilCardNote')"></i>
      </div>
      <div class="changeEditable" v-else>
        <el-input placeholder="备注信息" v-model="userDataEdit.dataOilCardNote" maxlength="30"></el-input>
        <i class="fa fa-check iconAble iconYes" title="保存" @click="saveUserInfo('OilCardNote')"></i>
        <i class="fa fa-remove iconAble iconNo" title="取消" @click="cancleUserInfo('OilCardNote')"></i>
      </div>
    </el-form-item>
  </el-form> -->

  <el-dialog title="活跃信息" :visible.sync="dialog.active.show" width="400px">
    <h2>基本信息</h2>
    <el-form label-width="150px">
      <el-form-item label="最近APP登录时间:">
        {{userInfo.strLoginTime}}
      </el-form-item>
      <el-form-item label="最近非APP登录时间:">
        {{userInfo.strLoginTime}}
      </el-form-item>
      <el-form-item label="混圈儿动态:">
        {{userInfo.topicCount}}条
      </el-form-item>
      <el-form-item label="累计评论:">
        {{userInfo.commentCount}}条
      </el-form-item>
      <el-form-item label="累计点赞:">
        {{userInfo.prasiedCount}}条
      </el-form-item>
    </el-form>
    <h2>开车赚钱</h2>
    <el-form label-width="150px">
      <el-form-item label="累计行程数:">
        {{userInfo.tripCount}}
      </el-form-item>
      <el-form-item label="完成天数:">
        {{userInfo.tripDayCount}}天
      </el-form-item>
      <el-form-item label="驾驶时间:">
        {{userInfo.timeCostCount}}分钟
      </el-form-item>
      <el-form-item label="累计里程:">
        {{userInfo.drivingDistanceCount}}km
      </el-form-item>
    </el-form>
  </el-dialog>

  <el-dialog title="修改驾驶证信息" :visible.sync="dialog.drvCard.show" width="400px">
    <el-form label-width="120px" class="elForm-w-d">
      <el-form-item label="驾驶证号:">
        <el-input placeholder="驾驶证号" v-model="userDataEdit.dataJszh"></el-input>
      </el-form-item>
      <el-form-item label="档案编号:">
        <el-input placeholder="档案编号" v-model="userDataEdit.dataDabh"></el-input>
      </el-form-item>
      <el-form-item label="姓名:">
        <el-input placeholder="真实姓名" v-model="userDataEdit.dataRealName"></el-input>
      </el-form-item>
      <el-form-item label="初次领证日期:">
        <el-date-picker
          v-model="userDataEdit.dataFirstBindDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="初次领证日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div class="dialogSubmitBtns">
      <el-button type="primary" @click="submitCusDrvInfo()">确认</el-button>
    </div>
  </el-dialog>

  <el-dialog title="加油记录" :visible.sync="dialog.oil.show" width="900px">
    <el-row class="lay-m-t-s lay-m-b-s inlineBlock">
      <el-col :span="6">油卡号：{{oilCardInfo.sinopecCardId || '-'}}</el-col>
      <el-col :span="6">主卡号：{{oilCardInfo.sinopecMasterCard || '-'}}</el-col>
      <el-col :span="6">持卡人姓名：{{oilCardInfo.cardOwner || '-'}}</el-col>
      <el-col :span="6">油卡办理城市：{{oilCardInfo.cardOwnCity || '-'}}</el-col>
    </el-row>
    <el-table :data="tableData"
              height="380"
              style="width: 100%;">
      <el-table-column
        prop="flownum"
        label="流水号">
      </el-table-column>
      <el-table-column
        prop="oilPoint"
        label="返利积分">
      </el-table-column>
      <el-table-column
        prop="dealTime2"
        label="交易时间">
      </el-table-column>
      <el-table-column
        prop="dealType"
        label="交易类型">
      </el-table-column>
      <el-table-column
        prop="dealMoney"
        label="交易金额">
      </el-table-column>
      <el-table-column
        prop="oilType"
        label="油品类型">
      </el-table-column>
      <el-table-column
        prop="oilCount"
        label="加油升数">
      </el-table-column>
      <el-table-column
        prop="oilPrice"
        label="油品单价">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult">
      </el-pagination>
    </div>
  </el-dialog>
</div>
</template>

<script>
// import { baseUrl3 } from '@/http/baseUrl';
import http from '@/api/label';
export default {
  name: 'customerUserInfo',
  props: ['mobile', 'update'],
  data () {
    return {
      localInfo: {
        memberName: '',
        unionID: '',
        mobile: '',
        memberAvatar: '',
        servicesSiteInfoList: []
      },
      userInfo: {
        memberId: '',
        city: '',
        commentCount: '',
        managerId: '',
        drivingDistanceCount: '',
        firstBindDate: '',
        isAgent: false,
        levelName: '',
        loginCount: 0,
        memberAvatar: '',
        memberEmail: '',
        memberName: '',
        memberSex: '',
        memberSign: '',
        mobile: '',
        prasiedCount: '',
        registerType: '',
        strLoginTime: '',
        strRegisterTime: '',
        timeCostCount: '',
        topicCount: '',
        tripCount: '',
        tripDayCount: '',
        vip: false,
        xm: '',
        cardList: [],
        curOilCard: {
          scardid: '',
          isMasterCard: '',
          describe: '',
          pageIndex: 0,
          pageSize: 10
        },
        isStar: ''
      },
      userDataEdit: {
        editEmail: false,
        dataEmail: '',
        editCity: false,
        dataProvince: '',
        dataCity: '',
        editRealName: false,
        dataRealName: '',
        dataJszh: '',
        dataDabh: '',
        dataFirstBindDate: '',
        editOilCardNote: false,
        dataOilCardNote: ''
      },
      dialog: {
        active: {
          show: false
        },
        drvCard: {
          show: false
        },
        oil: {
          show: false
        }
      },
      provinceList: [],
      cityList: [],
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      tableData: [],
      searchParams: {
        pageIndex: 0,
        pageSize: 10
      },
      oilCardInfo: {
        sinopecCardId: '',
        sinopecMasterCard: '',
        cardOwner: '',
        cardOwnCity: ''
      },
      ooia: false,
      statusList: [
        {
          value: 0,
          name: '退订'
        },
        {
          value: 1,
          name: '正常'
        },
        {
          value: 2,
          name: '欠费停发'
        },
        {
          value: 3,
          name: '账户变更短信解约或未绑定'
        },
        {
          value: 4,
          name: '关注状态停发'
        },
        {
          value: 99,
          name: '手动来自建行的数据赋值'
        }
      ]
    };
  },
  watch: {
    'update' () {
      // 先格式化data
      this.userInfo = {
        memberId: '',
        city: '',
        commentCount: '',
        drivingDistanceCount: '',
        firstBindDate: '',
        isAgent: false,
        levelName: '',
        loginCount: 0,
        managerId: '',
        memberAvatar: '',
        memberEmail: '',
        memberName: '',
        memberSex: '',
        memberSign: '',
        mobile: '',
        prasiedCount: '',
        registerType: '',
        strLoginTime: '',
        strRegisterTime: '',
        timeCostCount: '',
        topicCount: '',
        tripCount: '',
        tripDayCount: '',
        vip: false,
        xm: '',
        cardList: [],
        curOilCard: {
          scardid: '',
          isMasterCard: '',
          describe: '',
          pageIndex: 0,
          pageSize: 10
        },
        isStar: '',
        cardid: '',
        signDate: '',
        signStatus: ''
      };
      this.userDataEdit = {
        editEmail: false,
        dataEmail: '',
        editCity: false,
        dataProvince: '',
        dataCity: '',
        editRealName: false,
        dataRealName: '',
        dataJszh: '',
        dataDabh: '',
        dataFirstBindDate: '',
        editOilCardNote: false,
        dataOilCardNote: ''
      };
      this.dialog = {
        active: {
          show: false
        },
        drvCard: {
          show: false
        },
        oil: {
          show: false
        }
      };
      this.provinceList = [];
      this.cityList = [];
      this.currentPage = 1;
      this.totalResult = 0;
      this.totalPage = 0;
      this.tableData = [];
      this.searchParams = {
        pageIndex: 0,
        pageSize: 10
      };
      this.oilCardInfo = {
        sinopecCardId: '',
        sinopecMasterCard: '',
        cardOwner: '',
        cardOwnCity: ''
      };
      this.getData();
    }
  },
  created () {
    this.getData();
    this.ooia = this.$route.query.isStar;
  },
  methods: {
    // 获取数据
    getData () {
      this.axios.all([
        // 获取客户基本信息
        this.axios.get(`/member/memberInfo`, { params: { mobile: this.mobile } }),
        // 获取客户驾驶证信息
        // this.axios.get(`/member/memberDrvInfo`, { params: { mobile: this.mobile } }),
        // 获取客户管家信息
        // this.axios.get(`/memberInfo/activeInfo`, { params: { memberTel: this.mobile } }),
        // 获取客户油卡信息
        // this.axios.get(`/memberInfo/oilCardInfo`, { params: { memberTel: this.mobile } }),
        // 获取客户油卡信息
        this.axios.get(`/doubleTask/getDoubleSignInfo`, { params: { mobile: this.mobile } })
      ])
        .then(this.axios.spread((res1, res5) => {
          console.log(res1);
          if (res1.data.errorCode == 0) {
            if (res1.data.data) {
              this.userInfo.memberId = res1.data.data.oracleId;
              this.userInfo.managerId = res1.data.data.managerId;
              this.$store.state.memberId = this.userInfo.memberId;
              this.userInfo.isAgent = res1.data.data.isAgent;
              this.userInfo.city = res1.data.data.city;
              this.userInfo.memberName = res1.data.data.memberName;
              this.userInfo.memberSign = res1.data.data.memberSign;
              this.userInfo.memberAvatar = res1.data.data.memberAvatar;
              this.userInfo.levelName = res1.data.data.levelName;
              this.userInfo.memberSex = res1.data.data.memberSex;
              this.userInfo.svip = res1.data.data.svip;
              this.userInfo.vip = res1.data.data.vip;
              this.userInfo.memberEmail = res1.data.data.memberEmail;
              this.userInfo.mobile = this.mobile;
              /* this.userInfo.dabh = res2.data.resultData.dabh || '';
              this.userInfo.drvBindId = res2.data.resultData.drvBindId || '';
              this.userInfo.jszh = res2.data.resultData.jszh || '';
              this.userInfo.xm = res2.data.resultData.xm;
              this.userInfo.firstBindDate = res2.data.resultData.firstBindDate;
              this.userInfo.managerId = res3.data.resultData.managerId || '-';
              this.userInfo.registerType = res3.data.resultData.registerType || '-';
              this.userInfo.strRegisterTime = res3.data.resultData.strRegisterTime || '-';
              this.userInfo.loginCount = res3.data.resultData.loginCount || '-';
              this.userInfo.strLoginTime = res3.data.resultData.strLoginTime || '-';
              this.userInfo.topicCount = res3.data.resultData.topicCount || '0';
              this.userInfo.commentCount = res3.data.resultData.commentCount || '0';
              this.userInfo.prasiedCount = res3.data.resultData.prasiedCount || '0';
              this.userInfo.tripCount = res3.data.resultData.tripCount || '0';
              this.userInfo.tripDayCount = res3.data.resultData.tripDayCount || '0';
              this.userInfo.timeCostCount = res3.data.resultData.timeCostCount || '0';
              this.userInfo.drivingDistanceCount = res3.data.resultData.drivingDistanceCount || '0';
              this.userInfo.cardList = res4.data.resultData.cardList || [];
              this.userInfo.cardList.length > 0 && (this.userInfo.curOilCard = Object.assign({}, this.userInfo.cardList[0])); */
              this.userInfo.isStar = res1.data.data.isStar;
              this.provinceList = res1.data.data.provinceList;
            }
            this.userInfo.cardid = res5.data[0].cardid || '';
            this.userInfo.signDate = res5.data[0].regTime || '0';
            this.userInfo.signStatus = res5.data[0].logoutstatus || '';
            console.log(res5.data);
          } else {
            return this.$message.error(res1.data.errorMsg);
          }
        }));
      // 获取本地用户信息
      http.statistics({mobile: this.mobile}).then((res6) => {
        if (res6.errorCode == 0) {
          this.localInfo = {
            memberName: res6.data.name || '',
            unionID: res6.data.unionId || '',
            mobile: res6.data.mobile || '',
            memberAvatar: res6.data.avatar || '',
            servicesSiteInfoList: res6.data.servicesSiteInfoList || []
          };
        }
      });
    },
    // 同步双签状态
    syncState () {
      this.axios({
        url: `/member/syncDoubleSignUserState`,
        data: {
          memberId: this.userInfo.memberId,
          mobile: this.mobile
        },
        /* headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }, */
        method: 'post'
      })
        .then(res => {
          if (res.data.errorCode == 0) {
            this.$message.success('同步成功');
          } else {
            this.$message.error(res.data.errorMsg);
          }
        });
    },
    // 打开编辑-用户信息
    editUserInfo (str) {
      this.userDataEdit['edit' + str] = true;
      this.userDataEdit['data' + str] = '';
      if (str === 'City') {
        this.userDataEdit.dataProvince = '';
      } else if (str === 'OilCardNote') {
        this.userDataEdit.dataOilCardNote = this.userInfo.curOilCard.describe;
      }
    },
    // 设置星标 (0设置星标 1取消星标 与是否是星标正好相反)
    setStar (e) {
      let title = this.ooia ? '确定要取消星标吗?' : '确定要设置星标吗?';
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let param = {
            memberId: e.memberId,
            isStar: e.isStar ? '1' : '0'
          };
          this.axios
            .post(`/member/setMemberStar`, param)
            .then(res => {
              if (res.data.isSuccess) {
                // this.$router.go(0);
                this.getData();
                this.$message.success(res.data.message);
              } else {
                this.$message.info(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
    },
    // 保存编辑-用户信息
    saveUserInfo (str) {
      if (str === 'Email') {
        this.submitCusInfo({memberEmail: this.userDataEdit.dataEmail, memberId: this.userInfo.memberId}, () => {
          this.userDataEdit['edit' + str] = false;
        });
      } else if (str === 'City') {
        let provinceName = this.provinceList.find(e => {
          if (e.areaId === this.userDataEdit.dataProvince) {
            return e;
          }
        }).areaName;
        let cityName = this.cityList.find(e => {
          if (e.areaId === this.userDataEdit.dataCity) {
            return e;
          }
        }).areaName;
        this.submitCusInfo({
          city: provinceName + '|' + cityName,
          memberId: this.userInfo.memberId
        }, () => {
          this.userDataEdit['edit' + str] = false;
        });
      } else if (str === 'OilCardNote') {
        this.submitOilCard({describe: this.userDataEdit.dataOilCardNote}, () => {
          this.userDataEdit['edit' + str] = false;
        });
      }
    },
    // 取消编辑-用户信息
    cancleUserInfo (str) {
      this.userDataEdit['edit' + str] = false;
    },
    // 搜索城市
    searchCitys () {
      this.axios.get(`/member/cityList`, {
        params: {
          areaId: this.userDataEdit.dataProvince
        }
      })
        .then(res => {
          this.cityList = res.data.resultData;
        });
    },
    // 打开更多活跃信息弹窗
    openMoreActive () {
      this.dialog.active.show = true;
    },
    // 切换展示油卡
    changeSelectOilCard (val) {
      this.userInfo.cardList.find(e => {
        if (e.scardid === val) {
          this.userInfo.curOilCard.isMasterCard = e.isMasterCard;
          this.userInfo.curOilCard.describe = e.describe;
        }
      });
    },
    // 查询加油记录
    getAddOilRecord () {
      this.axios.get(`/memberInfo/oilCardConsum`, {
        params: {
          scardid: this.userInfo.curOilCard.scardid,
          pageIndex: this.searchParams.pageIndex,
          pageSize: this.searchParams.pageSize
        }
      })
        .then(res => {
          if (res.data.isSuccess) {
            this.dialog.oil.show = true;
            if (res.data.resultData.cardInfo) {
              this.oilCardInfo.sinopecCardId = res.data.resultData.cardInfo.sinopecCardId;
              this.oilCardInfo.sinopecMasterCard = res.data.resultData.cardInfo.sinopecMasterCard;
              this.oilCardInfo.cardOwner = res.data.resultData.cardInfo.cardOwner;
              this.oilCardInfo.cardOwnCity = res.data.resultData.cardInfo.cardOwnCity;
            }
            this.tableData = res.data.resultData.cardConsumeList.pageListData;
            this.totalResult = res.data.resultData.cardConsumeList.totalResult;
            this.totalPage = res.data.resultData.cardConsumeList.totalPage;
          }
        });
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getAddOilRecord();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getAddOilRecord();
    },
    // 提交修改客户基本信息
    submitCusInfo (param, cb) {
      this.axios.post(`/member/updateMemberInfo`, param)
        .then(res => {
          if (res.data.isSuccess) {
            'memberEmail' in param && (this.userInfo.memberEmail = this.userDataEdit.dataEmail);
            if ('city' in param) {
              let provinceName = this.provinceList.find(e => {
                if (e.areaId === this.userDataEdit.dataProvince) {
                  return e;
                }
              }).areaName;
              let cityName = this.cityList.find(e => {
                if (e.areaId === this.userDataEdit.dataCity) {
                  return e;
                }
              }).areaName;
              this.userInfo.city = provinceName + '|' + cityName;
            }
            cb && cb();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 提交客户油卡信息
    submitOilCard (param, cb) {
      param.scardid = this.userInfo.curOilCard.scardid;
      param.memberId = this.userInfo.memberId;
      this.axios.post(`/memberInfo/updateCardDescribe`, param)
        .then(res => {
          if (res.data.isSuccess) {
            this.userInfo.curOilCard.describe = this.userDataEdit.dataOilCardNote;
            this.getData();
            cb && cb();
          }
        });
    },
    // 打开修改驾驶证信息弹窗
    openDrvDialog () {
      this.dialog.drvCard.show = true;
      this.userDataEdit.dataRealName = this.userInfo.xm;
      this.userDataEdit.dataFirstBindDate = this.userInfo.firstBindDate;
      this.userDataEdit.dataJszh = this.userInfo.jszh;
      this.userDataEdit.dataDabh = this.userInfo.dabh;
    },
    // 提交修改客户驾驶信息
    /*
      // 用户姓名
      xm: this.userDataEdit.dataRealName,
      // 驾驶证号
      jszh: this.userInfo.jszh,
      // 档案编号
      dabh: this.userInfo.dabh,
      // 首次绑定日期
      firstBindDate: this.userInfo.firstBindDate
    * */
    submitCusDrvInfo () {
      if (this.userDataEdit.dataRealName === '') {
        return this.$message.error('请填写姓名');
      } else if (this.userDataEdit.dataJszh === '') {
        return this.$message.error('请填写驾驶证号');
      } else if (this.userDataEdit.dataDabh === '') {
        return this.$message.error('请填写档案编号');
      } else if (this.userDataEdit.dataFirstBindDate === '') {
        return this.$message.error('请填写初次领证日期');
      }
      let nowDate = new Date();
      let nowDateStr = nowDate.getFullYear() + '-' + ((nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)) + '-' + (nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate());
      let nowTime = new Date(nowDateStr).getTime();
      let editTime = new Date(this.userDataEdit.dataFirstBindDate).getTime();
      if (editTime > nowTime) {
        return this.$message.error('初次领证日期不能超过今日');
      }
      this.axios.post(`/member/updateMemberDrvInfo`, {
        memberId: this.userInfo.memberId,
        bindId: this.userInfo.drvBindId,
        xm: this.userDataEdit.dataRealName,
        jszh: this.userDataEdit.dataJszh,
        dabh: this.userDataEdit.dataDabh,
        firstBindDate: this.userDataEdit.dataFirstBindDate
      })
        .then(res => {
          if (res.data.isSuccess) {
            this.userInfo.xm = this.userDataEdit.dataRealName;
            this.userInfo.jszh = this.userDataEdit.dataJszh;
            this.userInfo.dabh = this.userDataEdit.dataDabh;
            this.userInfo.firstBindDate = this.userDataEdit.dataFirstBindDate;
            this.dialog.drvCard.show = false;
            this.$message.success('修改成功');
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#customerUserInfo{float: left; width: 310px;}
.titleTyle{
  border-left:6px solid #409EFF;
  padding-left:8px;
  font-size: 18px;
  margin-top:15px;
}
.container{padding: 10px;}
.headBox{padding: 20px 0;}
.userHead{
  img{width: 60px; height: 60px;}
}

.changeEditable{
  & > .el-input{width: 130px;}
  & > .el-select{width: 75px;}
}
.el-form.elForm-w-d{width: 320px;}
.el-date-editor.el-input, .el-date-editor.el-input__inner{width: 200px;}

.lineRight{position: absolute; right: 0; top: 0;}

.likeA{cursor: pointer; color: $theme-color-blue;
  &:hover{text-decoration: underline;}}

.iconAble{margin-left: 5px; cursor: pointer; font-size: 16px;}
.edit:hover{color: $theme-color-blue;}

.el-form-item{margin-bottom: 0;}

.lmtWid{float: left; max-width: 85%;}
.el-icon-star-on:before {
  font-size: 18px;
}
</style>
<style lang="scss">
.changeEditable.a1 > .el-select .el-input--suffix .el-input__inner{padding-left: 5px;}
</style>



// WEBPACK FOOTER //
// src/components/customerCheck/userInfo.vue